import React, { useContext } from 'react';

// import context
import { ProductContext } from './ProductContext';

// import components
import Product from './Product';

// import Link
import { Link } from 'react-router-dom';

// import icons
import { ImSpinner2 } from 'react-icons/im'

const HouseList = () => {
  const {products, loading } = useContext(ProductContext);

  // if loading is true
  if (loading) {
    return(<ImSpinner2 className='mx-auto animate-spin text-green-500 text-4xl mt-[200px]'/>)
  }

  if(products.length < 1){
    return <div className='text-center text-3xl text-gray-400 mx-auto mb-20'>Sorry, nothing was found</div>
  }

  return (
      <section className='mb-20 '>
        <div className='container mx-auto'>
          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-14'>
            {products.map((product, index)=>{
              return (
                <Link to={`/product/${product.id}`} key={index}>
                  <Product product={product}/>
                </Link>
              )
            })}
          </div>
        </div>
      </section>
    )
};

export default HouseList;
